import {
  clientListFailure,
  clientListRequest,
  clientListSuccess,
} from 'store/reducers/clientList';

import { fetchData } from './fetchData';

export const loadClientList =
  ({ page, query }) =>
  (dispatch, getState) => {
    const { provider } = getState();
    const luid = provider.locations?.[0]?.uuid;

    const searchQuery = query ? `&q=${query}` : '';

    return fetchData({
      endpoint: `location/${luid}/animals?page=${page || 1}${searchQuery}`,
      currentPagination: +page,
      actions: [clientListRequest, clientListSuccess, clientListFailure],
    })(dispatch, getState);
  };

export const patchAnimal = (auid, body) => (dispatch, getState) => {
  if (!auid) return;
  const luid = getState().provider.locations[0].uuid;

  return fetchData({
    endpoint: `location/${luid}/animals/${auid}`,
    actions: [null, null, null],
    httpMethod: 'patch',
    body,
  })(dispatch, getState);
};
